import { render, staticRenderFns } from "./pinglun.vue?vue&type=template&id=7fe90303&scoped=true&"
import script from "./pinglun.vue?vue&type=script&lang=js&"
export * from "./pinglun.vue?vue&type=script&lang=js&"
import style0 from "./pinglun.vue?vue&type=style&index=0&id=7fe90303&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe90303",
  null
  
)

export default component.exports